module.exports = __webpack_public_path__ + "media/images/pic/courses/8-f71ca3d91a9563b043f20b51a9c9b47f.jpeg";